import {BehaviorSubject} from "rxjs";

export const TaskPageData$ = new BehaviorSubject<any>(null);

TaskPageData$.subscribe(
    val => {
        console.debug( 'smtTaskPageData$', val )
    }
)
